import React, { useMemo } from 'react';
import getFormattedValue from 'store/redux/utils/getFormattedValue';
import { RoiDefinition, RoasDefinition } from 'components/NameDefinition';
import { Typography } from 'antd';
import PropTypes from 'prop-types';
import { mdiCashMultiple, mdiCreditCard, mdiBank } from '@mdi/js';
import {
  ValueDotFormatter,
  RoiFormatter,
  RoasFormatter,
} from 'components/tables/NinjaTable/formatters';
import WidgetCard from './WidgetCard';
import ReportInfo from 'components/ReportInfo/ReportInfo';
import { useWidget } from 'components/Widget/useWidget';

const NetworkWidget = ({ height, data, network = null }) => {
  const { filters } = useWidget();

  const metrics = useMemo(() => {
    return [
      {
        icon: mdiCreditCard,
        label: 'Ad Spent',
        value: (
          <>
            {getFormattedValue(data?.ad_spent)}
            <ReportInfo
              type='ad_spent'
              info={{
                ...filters,
                ...(network && { network }),
              }}
            />
          </>
        ),
      },
      {
        icon: mdiBank,
        label: 'Gross Income',
        value: (
          <>
            <ValueDotFormatter value={data?.gross_income} />
            <ReportInfo
              type='gross_income'
              info={{
                ...filters,
                ...(network && { network }),
              }}
            />
          </>
        ),
      },
      {
        icon: mdiCashMultiple,
        label: 'Gross Profit',
        value: (
          <>
            {getFormattedValue(data?.gross_profit)}
            <ReportInfo
              type='gross_profit'
              info={{
                ...filters,
                ...(network && { network }),
              }}
            />
          </>
        ),
      },
      {
        icon: mdiCashMultiple,
        label: 'Net Profit',
        value: (
          <>
            {getFormattedValue(data?.net_profit)}
            <ReportInfo
              type='net_profit'
              info={{
                ...filters,
                ...(network && { network }),
              }}
            />
          </>
        ),
      },
      {
        label: <RoasDefinition showIcon />,
        formatter: () => <RoasFormatter row={data} fontSize={18} />,
      },
      {
        label: <RoiDefinition showIcon />,
        formatter: () => <RoiFormatter row={data} fontSize={18} />,
      },
    ];
  }, [data, filters, network]);

  return (
    <div
      style={{ height: height }}
      className='grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-4 m-auto items-center h-full w-full'
    >
      {metrics.map((metric, index) => (
        <WidgetCard key={index} {...metric} />
      ))}
    </div>
  );
};

export default NetworkWidget;

NetworkWidget.propTypes = {
  data: PropTypes.object.isRequired,
};
